export default {"src":"/_next/static/media/managed-services.9ffe46c9.svg","height":92,"width":108};